import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4 17h12V7H4v10zm4-8v2h4V9l3 3-3 3v-2H8v2l-3-3 3-3z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 13h4v2l3-3-3-3v2H8V9l-3 3 3 3zm10-3.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zM16 17H4V7h12v10z"
})), 'SwitchVideoTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SwitchVideoTwoTone.js
// module id = 6632
// module chunks = 2